<template>
  <div>
    <CoolLightBox
      :items="items"
      :index="index"
      @close="index = null"
    />

    <div class="photo-gallery">
      <div
        v-for="(image, imageIndex) in itemsToShow"
        :key="imageIndex"
        class="photo-gallery__image-wrap"
        @click="index = imageIndex"
      >
        <content-loader
          v-if="!myData"
          class="carousel-slider__image-container"
          :speed="3"
          :animate="true"
          width="232"
          height="150"
        />

        <div
          v-else
          :style="{ backgroundImage: 'url(' + image.src + ')' }"
          class="photo-gallery__image"
        />
      </div>
    </div>

    <button
      v-if="limit && items.length > limit"
      class="photo-gallery__link"
      @click="limit = null"
    >
      <strong>Show all ({{ items.length }})</strong>
    </button>
    <button
      v-if="!limit && items.length > limit"
      class="photo-gallery__link"
      @click="limit = 4"
    >
      <strong>Show less</strong>
    </button>
  </div>
</template>

<script>
import CoolLightBox from 'vue-cool-lightbox';
import { ContentLoader } from 'vue-content-loader';

import 'vue-cool-lightbox/dist/vue-cool-lightbox.min.css';

export default {
  components: {
    CoolLightBox,
    ContentLoader,
  },
  props: {
    items: { required: true, type: Array },
  },
  data() {
    return {
      myData: null,
      limit: 4,
      index: null,
    };
  },
  computed: {
    itemsToShow() {
      return this.limit ? this.items.slice(0, this.limit) : this.items;
    },
  },
  mounted() {
    setTimeout(() => {
      this.myData = 'Photo Gallery';
    }, 3000);
  },
  methods: {},
};
</script>
